import { format } from 'date-fns'
import { ClientCompany, ClientName, ContactWrapper, FundsSourceIcon } from './styles'
import { RegistrationDate, MailIcon, PhoneIcon } from './styles'
import { HorizontalWrapper, TagList, Tag } from './styles'
import { useTranslation } from 'react-i18next'
import { OkIcon, NotOkIcon } from 'components/Icons'
import { Domiciliation } from 'globals/models/Domiciliation'
import ClientStatus from 'components/ClientStatus'

interface IProps {
  domiciliation: Domiciliation
}

const ClientBaseInfos = (props: IProps) => {
  const { domiciliation } = props
  const { t } = useTranslation()
  const ownAddress = domiciliation.address?.ownAddress
  const clientName = `${domiciliation.firstname} ${domiciliation.lastname}`
  const registrationDate = format(new Date(domiciliation.clientSince), 'dd/MM/yyyy')

  return (
    <>
      <HorizontalWrapper>
        <ClientCompany>{domiciliation.society.name}</ClientCompany>
        <ClientStatus status={domiciliation.status} />
      </HorizontalWrapper>
      <HorizontalWrapper>
        <ClientName>{clientName}</ClientName>
        <RegistrationDate>{t('clients.registration-date', { date: registrationDate })}</RegistrationDate>
      </HorizontalWrapper>

      <TagList>
        <Tag>{t('global.id')} : {domiciliation.id}</Tag>

        {(domiciliation.subscriptionState == 'payment_failed') &&
          <Tag>
            {t('mails.processing.unpaid')}
            <NotOkIcon />
          </Tag>
        }

        <Tag>
          {t('clients.procuration')}
          {domiciliation.postalProcurationReady ? <OkIcon /> : <NotOkIcon />}
        </Tag>

        <Tag>{t('clients.mail-options.' + domiciliation.userMailOption)}</Tag>

        { domiciliation.npai &&
          <Tag color={'red'}>
            NPAI
            <NotOkIcon />
          </Tag>
        }
      </TagList>

      <ContactWrapper>
        {!ownAddress &&
          <>
            <MailIcon />{domiciliation.email}
            <PhoneIcon />{domiciliation.phoneNumber}
          </>
        }
        <FundsSourceIcon />{domiciliation.firstPaymentCountryOrigin}
      </ContactWrapper>

      {domiciliation.cancelationReason &&
        <ContactWrapper>
          {t('clients.cancelationReason')}
          {' : '}
          {t(`clients.cancelationReasons.${domiciliation.cancelationReason}`)}
        </ContactWrapper>
      }
    </>
  )
}

export default ClientBaseInfos
